// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/bar
import { ResponsiveBar } from '@nivo/bar';

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export function BarChart(props: any) {
    return (
        <ResponsiveBar
            data={props.data}
            keys={['Current', 'ClearCOGS']}
            indexBy="day"
            valueFormat={props.format}
            margin={{ top: 40, right: 40, bottom: 70, left: 60 }}
            padding={0.3}
            groupMode="grouped"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={({ id, data }) =>
                String(
                    data[`${!props.responsive ? id : id + 'Responsive'}Color`]
                )
            }
            borderColor={{
                from: 'color',
                modifiers: [['darker', 1.6]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
            }}
            gridYValues={5}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                tickValues: 5,
                format: function (value) {
                    return `$${value}`;
                },
            }}
            enableLabel={false}
            labelTextColor={{
                from: 'color',
                modifiers: [['darker', 1.6]],
            }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'top',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: -30,
                    itemsSpacing: 40,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.75,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            theme={{
                legends: {
                    text: {
                        fontSize: 13,
                        fontWeight: 'bold',
                    },
                },
            }}
            role="application"
            ariaLabel="ClearCOGS demo chart"
            barAriaLabel={function (e) {
                return (
                    e.id + ': ' + e.formattedValue + ' in week: ' + e.indexValue
                );
            }}
        />
    );
}
